export default __webpack_public_path__ + "static/0241-cb71a09095f49cf2d13bac867424c36a.png";